import 'css-chunksrc/client/common/secondaryCriteriaForm/documentForm/image/styles.scss';export default {
  "addIcon": "_addIcon_k9d9n_1"
};